export default "/images/c2133b7151d9d3a76fc0dec180ba388d.avif";